import { render, staticRenderFns } from "./TarifEdit.vue?vue&type=template&id=44d2e68f&scoped=true&"
import script from "./TarifEdit.vue?vue&type=script&lang=js&"
export * from "./TarifEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2e68f",
  null
  
)

export default component.exports